import { ReactNode, useContext } from 'react';
import { SidebarContext } from '@/common/components/sidebar/SidebarContext.ts';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from '@/common/components/ui/sheet';
import { Scrollable } from '@/common/components/scrollable/Scrollable.tsx';
import { cn } from '@/lib/utils';

export interface SidebarProps {
  backgroundColor?: string;
  width?: string | number;
  className?: string;
  children?: ReactNode;
}

const SidebarContent = ({ children }: { children?: ReactNode }) => (
  <Scrollable>
    <div className="p-4">{children}</div>
  </Scrollable>
);

export const Sidebar = ({ backgroundColor, width, className, children }: SidebarProps) => {
  const { isOpen, onClose } = useContext(SidebarContext);

  return (
    <Sheet open={isOpen} onOpenChange={(open) => !open && onClose?.()}>
      <SheetContent
        side="right"
        className={cn('flex flex-col p-0', className)}
        style={{
          width: width ? (typeof width === 'number' ? `${width}px` : width) : undefined,
          backgroundColor: backgroundColor,
        }}
      >
        {children}
      </SheetContent>
    </Sheet>
  );
};

Sidebar.Header = SheetHeader;
Sidebar.Title = SheetTitle;
Sidebar.Description = SheetDescription;
Sidebar.Content = SidebarContent;
